import { PropsWithChildren } from 'react';

export const Container = ({ children }: PropsWithChildren) => (
    <nav className={`absolute inset-0 overflow-x-clip overflow-y-scroll pt-24`}>
        <ul className={`flex h-full flex-col justify-start gap-2`}>
            {children}
        </ul>
    </nav>
);
